import { render } from "./ObstetricsAndGynaecology.vue?vue&type=template&id=5436f877&scoped=true"
import script from "./ObstetricsAndGynaecology.vue?vue&type=script&lang=ts"
export * from "./ObstetricsAndGynaecology.vue?vue&type=script&lang=ts"

import "./ObstetricsAndGynaecology.vue?vue&type=style&index=0&id=5436f877&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5436f877"

export default script